export default "__VITE_ASSET__BLLQgog2__"